module.exports = __webpack_public_path__ + "static/media/3.805dc1d5.png";